export default function progressionDashboardData(data) {
	return {
		level1Progress: data.user.progressionData.level1Progress,
		level1DoneDate: (data.user.progressionData.level1DoneTimestamp ? new Date(data.user.progressionData.level1DoneTimestamp) : null),
	}
}